export enum EditPhaseKinds {
  /** 初回書類作成時 */
  EditStartFirst,
  /** 書類作成時 */
  EditStart,
  /**
   * 患者情報更新ボタンクリック時を想定していた？現状では処理対象が無く中途半端になっている。
   * 余裕のあるタイミングでこちらを廃止してPatientInformationManualUpdateに統合したほうが良さそう。
   */
  ManualUpdate,
  TemporarySave,  // 不要かも
  /** 保存時 */
  Save,
  /** 印刷時 */
  Print,
  /** 計算ボタンクリック時 */
  Calculate,
  /** 患者情報更新ボタンクリック時 */
  PatientInformationManualUpdate,

  // ------- 以下、WF用-------------

  /** WF依頼書記載開始時 */
  WorkflowRequest = 2000,
  /** 設定によってタイミングが変化する項目たち */
  WorkflowConfig = 2001,

  /** 下書きで文書作成 */
  WorkflowDraftCreate = 2200,
  /** 下書きで文書編集(初回) */
  WorkflowDraftEditFirst = 2201,
  /** 下書きで文書編集(2回目以降) */
  WorkflowDraftEdit = 2202,

  /** 作成1で文書作成 */
  WorkflowMake1Create = 2300,
  /** 作成1で文書編集(初回) */
  WorkflowMake1EditFirst = 2301,
  /** 作成1で文書編集(2回目以降) */
  WorkflowMake1Edit = 2302,

  /** 作成2で文書作成 */
  WorkflowMake2Create = 2400,
  /** 作成2で文書編集(初回) */
  WorkflowMake2EditFirst = 2401,
  /** 作成2で文書編集(2回目以降) */
  WorkflowMake2Edit = 2402,

  // WorkflowRecognize -> 承認進捗＝文書参照＋承認 なので、バックエンドで承認者をセットする。そのためフロントには定義しない。

}
